// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"618268dc","362":"52e34e2b","488":"08e54546","918":"b595ec56"}[chunkId] + ".chunk.js";
};